import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Text } from 'foundations-components/components/Text';
import { HelpContent } from '../HelpContent';
import { emailRegex } from '../../constants/validation';
import { jsx as _jsx } from "react/jsx-runtime";
export function EmailStepItem({
  item,
  label,
  params,
  onChange
}) {
  var _item$tooltip;
  const value = params[item.name];
  const isInvalid = value ? !emailRegex.test(value) : false;
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: item.required,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    help: /*#__PURE__*/_jsx(HelpContent, {
      helpData: item.help
    }),
    error: isInvalid,
    validationMessage: isInvalid ? /*#__PURE__*/_jsx(Text, {
      as: "small",
      use: "error",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "auth.defaultValidationErrors.Email"
      })
    }) : null,
    children: /*#__PURE__*/_jsx(TextInput, {
      type: "email",
      onChange: event => onChange(item.name, event.target.value),
      value: value
    })
  });
}